
import useMount from "react-use/lib/useMount";
import logPageView from "lib/ga/pageView";
import useAsyncFn from "react-use/lib/useAsyncFn";
import { useDispatch } from "react-redux";
import axios from "axios";
import useReducer, { ReducerProvider } from "./reducer";
import logEvent from "lib/ga/miscEvent";
import { useEffect, useRef, useContext, useState } from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import styles from '../sales.module.css';
import { Context } from 'context/context';
import TextInput from "components/Modal/ContactUs/TextInput";
import TextArea from "components/Modal/ContactUs/TextArea";
import SelectInput from "components/Modal/ContactUs/SelectInput";
import { modalSet } from "_slices/view";
import { useRouter } from 'next/navigation';


export const validationChecks = (data) => {
    let errors: string[] = [];
    let mailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let textErrors = {
        name: "name",
        email: "email",
        phone: "phone",
        company: "company",
        message: "message",
        reason: "reason for contacting"
    }

    Object.keys(data).forEach((item) => {
        if (data[item] === '') {
            errors.push(`You have entered a invalid ${textErrors[item]}`)
        } else if (data[item].length < 2) {
            errors.push(`You have entered a invalid ${textErrors[item]}`)
        } else if (item === 'email' && !data[item].match(mailformat)) {
            errors.push('You have entered a invalid email address')
        } else if (item === 'phone' && data[item].length < 7) {
            errors.push("You have entered a invalid phone number")
        }
    })

    return errors;
}


const ContactPage = ({ reasons = [], showExtraContact = false, subHeading = '' }) => {

    const { state } = useContext(Context);
    const [loggedIn] = useState(state.user.loggedIn);
    const router = useRouter();
    const reduxDispatch = useDispatch();
    const [{ contactForm }, dispatch] = useReducer();
    const ref = useRef<HTMLDivElement>(null);
    let [errorMessage, setErrorMessage] = useState<string | string[]>('');
    let [successMessage, setSuccessMessage] = useState(false);
    let [formSent, setFormSent] = useState(false);

    const scrollToElement = () => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        scrollToElement();
        if (reasons.length === 1) {
            dispatch({ type: "contactFormInput", payload: { reason: reasons[0] } })
        }
    }, []);

    const validationChecksMeth = (data) => {
        const errors = validationChecks(data);

        if (errors.length > 0) {
            setErrorMessage(errors)

            return false
        }
        return true;
    }

    const [mailState, sendMail] = useAsyncFn(async () => {
        setFormSent(true);
        setErrorMessage('');

        if (!loggedIn) {
            setFormSent(false);
            reduxDispatch(modalSet({ visible: true, type: "auth", view: "login", router }))
            return 'bad'
        }

        if (!validationChecksMeth(contactForm.inputs)) {
            setFormSent(false);
            return 'bad'
        }
        try {
            const { data, status } = await axios.post(
                `${process.env.NEXT_PUBLIC_APP_URL}/api/mail/contactUs`,
                {
                    ...contactForm.inputs,
                    agent: '128599',
                    url: window.location.href,
                },
                {
                    headers: {
                        accept: "application/json",
                        "content-type": "application/json",
                    },
                }
            );
            if (Math.floor(status / 100) === 2) {
                setSuccessMessage(true)
                logEvent({
                    category: "Contact us",
                    action: "Contact us form submit",
                    label: contactForm.inputs.reason,
                });
                dispatch({ type: "contactFormReset" });
                setFormSent(false);
                return data;
            } else {
                setErrorMessage("We couldn't send your message right now. Please try again in a minute.");
                setFormSent(false);
                return "BAD";
            }
        } catch (error) {
            setErrorMessage("We couldn't send your message right now. Please try again in a minute.");
            setFormSent(false);
            return "BAD";
        }
    }, [contactForm]);

    useMount(() => {
        logPageView({ url: window.location.pathname + window.location.search });
    });

    return <div className={`${styles.AgentContainer} ${styles.contact}`} id='contactForm'>
        <h2>Get in touch</h2>
        {showExtraContact && (
            <>
                <p><PhoneIcon />01483 238920</p>
                <p><LocationOnIcon />Completely Retail, 51-53 High Street, Guildford, Surrey, GU1 3DY</p>
            </>
        )}

        {subHeading && (
            <p>{subHeading}</p>
        )}

        {successMessage && (
            <div>
                <CheckCircleOutlineIcon sx={{ fontSize: '50px', color: '#941E3A', marginBottom: '10px' }} />
                <h2>Thank you for getting in touch!</h2>
                <p>We appreciate you contacting us. One of our colleagues will get back in touch soon.</p>
            </div>
        )}

        {!successMessage && (
            <form className={styles.contactForm2}>
                <TextInput type='text' showText={false} name="name" label="Name" placeholder="Name" required={true} value={contactForm.inputs.name} onInputChange={(e) => {
                    dispatch({ type: "contactFormInput", payload: { name: e } })
                }} />


                <TextInput type='text' showText={false} name="Company" label="Company" placeholder="Company" required={false} value={contactForm.inputs.company} onInputChange={(e) => {
                    dispatch({ type: "contactFormInput", payload: { company: e } })
                }} />

                <TextInput type='text' showText={false} name="Email" label="Email" placeholder="Email" required={true} value={contactForm.inputs.email} onInputChange={(e) => {
                    dispatch({ type: "contactFormInput", payload: { email: e } })
                }} />

                <TextInput type='text' showText={false} name="Phone" label="Phone" placeholder="Phone" required={true} value={contactForm.inputs.phone} onInputChange={(e) => {
                    dispatch({ type: "contactFormInput", payload: { phone: e } })
                }} />


                <TextArea name="Message" label="Message" showText={false} extraClass={styles.inputFullWidth} placeholder="Message" required={true} value={contactForm.inputs.message} onInputChange={(e) => {
                    dispatch({ type: "contactFormInput", payload: { message: e } })
                }} />

                {
                    reasons.length > 1 && (
                        <SelectInput label="Reason for contacting" extraClass={styles.inputFullWidth} onInputChange={(e) => {
                            dispatch({ type: "contactFormInput", payload: { reason: e } });
                        }} value={contactForm.inputs.reason} required={true} options={reasons} defaultOption="Reason for contacting" />
                    )
                }

                {errorMessage && (
                    <div className={styles.errorContanier}>
                        {Array.isArray(errorMessage) && (
                            <ul>
                                {errorMessage.map((message, index) => {
                                    return <li key={index}>{message}</li>;
                                })}
                            </ul>
                        )}

                        {
                            !Array.isArray(errorMessage) && (
                                <>{errorMessage}</>
                            )
                        }
                    </div>
                )}
                <div className={styles.contactButtonContainer}>
                    <button type="button" className={styles.contactButton} disabled={formSent} onClick={(e) => { e.preventDefault; sendMail(); }} >Submit</button>
                </div>
            </form>
        )
        }
    </div>


};

const ContactUs = (props) => {
    return (
        <ReducerProvider>
            <ContactPage {...props} />
        </ReducerProvider>
    );
};

export default ContactUs;
